module.exports = __webpack_public_path__ + "static/media/slide_34_left_img.4d64cdfe.png";